'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _defaultBreakpointProvider = require('./breakpoints/defaultBreakpointProvider');

var _defaultBreakpointProvider2 = _interopRequireDefault(_defaultBreakpointProvider);

var _resolveBreakpoints = require('./breakpoints/resolveBreakpoints');

var _resolveBreakpoints2 = _interopRequireDefault(_resolveBreakpoints);

var _buildApi = require('./build/buildApi');

var _buildApi2 = _interopRequireDefault(_buildApi);

var _buildDeclaration = require('./build/buildDeclaration');

var _buildDeclaration2 = _interopRequireDefault(_buildDeclaration);

var _expandData = require('./build/expandData');

var _expandData2 = _interopRequireDefault(_expandData);

var _expandStyles = require('./build/expandStyles');

var _expandStyles2 = _interopRequireDefault(_expandStyles);

var _defaultConfig = require('./config/defaultConfig');

var _defaultConfig2 = _interopRequireDefault(_defaultConfig);

var _breakpoints = require('./utils/breakpoints');

var _config = require('./utils/config');

var _functions = require('./utils/functions');

var _objects = require('./utils/objects');

var _predicate = require('./utils/predicate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeWithDefaultConfig = (0, _ramda.mergeDeepRight)(_defaultConfig2.default);

var ensureDataScopes = (0, _ramda.over)(_config.lDataScopes, _functions.defaultToArray);

var createDefaultBreakpointProvider = (0, _ramda.compose)(_defaultBreakpointProvider2.default, _breakpoints.addDefaultBreakpoint);

var ensureBreakpointProvider = (0, _ramda.over)(_config.lBreakpoints, (0, _ramda.unless)(_predicate.isBreakpointProvider, createDefaultBreakpointProvider));

var createDeclarationProcessor = function createDeclarationProcessor(breakpointProvider, name, data, style) {
  return (0, _ramda.pipe)((0, _resolveBreakpoints2.default)(breakpointProvider), (0, _buildDeclaration2.default)(name, data, style));
};

var createDeclarationProcessorReducer = function createDeclarationProcessorReducer(breakpointProvider, data) {
  return function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        style = _ref2[1];

    return (0, _ramda.pipe)(createDeclarationProcessor, (0, _ramda.assoc)(name, _ramda.__, acc))(breakpointProvider, name, data, style);
  };
};

var createDeclarationProcessors = function createDeclarationProcessors(_ref3) {
  var breakpoints = _ref3.breakpoints,
      data = _ref3.data,
      api = _ref3.api;
  return (0, _objects.reduceObjIndexed)(createDeclarationProcessorReducer(breakpoints, data), {}, api);
};

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

var api = (0, _ramda.pipe)(_functions.defaultToObj, mergeWithDefaultConfig, ensureDataScopes, _expandData2.default, _expandStyles2.default, ensureBreakpointProvider, createDeclarationProcessors, _buildApi2.default);

exports.default = api;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/cssapi.js
// module id = 655
// module chunks = 168707334958949